import { z } from 'zod';

import { ANALYTICS_KPIS, DELIVERY_NOTE_KPIS, USER_KPIS } from './constants';

export const zodAnalyticsKpiQueryParamsSchema = z.object({
  dateRange: z.object({
    dateFrom: z.iso.date(),
    dateTo: z.iso.date(),
  }),
  kpiName: z.enum(ANALYTICS_KPIS),
});

export const zodAnalyticsKpiResponseSchema = z.object({
  value: z.number().nullable(),
  previousValue: z.number().nullish(),
});

export const zodAnalyticsKpiEndpointSchema = z.union([
  z.tuple([z.literal('user'), z.literal('activity'), z.enum(USER_KPIS)]),
  z.tuple([
    z.literal('delivery_note'),
    z.literal('statistics'),
    z.enum(DELIVERY_NOTE_KPIS),
  ]),
]);
